import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { DefaultRoutingComponent } from './default-routing/default-routing.component';
import { CreateAccountComponent } from './list/create-account/create-account.component';
import { AccountListHomeComponent } from './list/account-list-home/account-list-home.component';
import { AccountHomeComponent } from './home/account-home/account-home.component';
import { AccountScoreHomeComponent } from './scores/account-score-home/account-score-home.component';
import { AccountInboxHomeComponent } from './inbox/account-inbox-home/account-inbox-home.component';
import { AccountEngagementHomeComponent } from './engagement/account-engagement-home/account-engagement-home.component';
import { AccountSettingsHomeComponent } from './settings/account-settings-home/account-settings-home.component';
import { AccountSettingsProjectComponent } from './settings/account-settings-project/account-settings-project.component';
import { AccountSettingsUserAccessComponent } from './settings/account-settings-user-access/account-settings-user-access.component';
import { AccountSettingsDashboardConfigureComponent } from './settings/account-settings-dashboard-configure/account-settings-dashboard-configure.component';
import { AccountSettingsSecurityComponent } from './settings/account-settings-security/account-settings-security.component';
import { AccountSettingsNotificationComponent } from './settings/account-settings-notification/account-settings-notification.component';
import { RelationshipViewComponent } from './relationship-view/relationship-view.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { AdminPanelComponent } from 'src/app/shared/components/admin-panel/admin-panel.component';
const accountsRoutes: Routes = [{
    path: 'accounts',
    component: DefaultRoutingComponent,
    children: [
      { path: '', canActivate: [AuthGuard], pathMatch: 'full', component: AccountListHomeComponent },
      { path: 'home', canActivate: [AuthGuard], pathMatch: 'full', component: AccountHomeComponent },
      { path: 'create', canActivate: [AuthGuard], pathMatch: 'full', component: CreateAccountComponent },
      { path: 'scores', canActivate: [AuthGuard], pathMatch: 'full', component: AccountScoreHomeComponent },
      { path: 'inbox', canActivate: [AuthGuard], pathMatch: 'full', component: AccountInboxHomeComponent },
      { path: 'engagement', canActivate: [AuthGuard], pathMatch: 'full', component: AccountEngagementHomeComponent },
      { path: 'relationship', canActivate: [AuthGuard], pathMatch: 'full', component: RelationshipViewComponent },
      { path: 'settings/general', canActivate: [AuthGuard], pathMatch: 'full', component: AccountSettingsHomeComponent },
      { path: 'settings/project', canActivate: [AuthGuard], pathMatch: 'full', component: AccountSettingsProjectComponent },
      { path: 'settings/user-access', canActivate: [AuthGuard], pathMatch: 'full', component: AccountSettingsUserAccessComponent },
      { path: 'settings/configure-dashboard', canActivate: [AuthGuard], pathMatch: 'full', component: AccountSettingsDashboardConfigureComponent },
      { path: 'settings/security', canActivate: [AuthGuard], pathMatch: 'full', component: AccountSettingsSecurityComponent },
      { path: 'settings/notification', canActivate: [AuthGuard], pathMatch: 'full', component: AccountSettingsNotificationComponent },
      { path: 'settings/admin', canActivate: [AuthGuard], pathMatch: 'full', component: AdminPanelComponent }
    ]
  }

];
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(accountsRoutes)
  ],
  exports: [RouterModule]
})
export class AccountsRoutingModule {}
